import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import withRestrictedAccess from '../../higherOrderComponents/withRestrictedAccess';
import Integrations from '../../components/Resources/integrationNew/Integrations';

const IntegrationResources = () => (
  <div className='page-container'>
    <Integrations />
  </div>
);

const enhance = compose(
  injectIntl,
  withRouter,
  connect((state) => state),
  withRestrictedAccess
);

export default enhance(IntegrationResources);
